import React from 'react';
import styles from './index.module.scss';

var ProductHuntFeaturedBadge = function ProductHuntFeaturedBadge() {
  return /*#__PURE__*/React.createElement("a", {
    href: "https://www.producthunt.com/posts/jokerdad?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-jokerdad",
    target: "_blank",
    rel: "noreferrer",
    className: styles.badge
  }, /*#__PURE__*/React.createElement("img", {
    src: "https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=335997&theme=light",
    alt: "JokerDad - JokerDad is a chrome extension shows a joke in your new tabs | Product Hunt",
    style: {
      width: 250,
      height: 54
    },
    width: "250",
    height: "54"
  }));
};

export default ProductHuntFeaturedBadge;